import React, { useState } from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Check, X } from 'lucide-react';
export const PricingSection = () => {
  const [plan, setPlan] = useState<'standard' | 'premium'>('premium');
  const plans = {
    standard: {
      id: 'standard',
      icon: '📘',
      title: 'MEGAPACK NOCHES DE PAZ',
      subtitle: '5 Tomos + 5 Bonos',
      ideal: 'Ideal para: Familias que buscan el sistema base probado.',
      oldPrice: '$61.000',
      price: '$19.990',
      url: 'https://mundopractico.online/cart/48588077203673:1',
      buttonText: 'MEGAPACK'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      title: 'MEGAPACK + RECONEXIÓN',
      subtitle: '5 Tomos + 5 Bonos + Guía de Pareja Post-Caos',
      ideal: 'Ideal para: Parejas que quieren recuperar su descanso y su conexión.',
      oldPrice: '$79.000',
      price: '$27.990',
      url: 'https://mundopractico.online/cart/48588081660121:1',
      buttonText: 'MEGAPACK + RECONEXIÓN',
      isPopular: true
    }
  };
  const currentPlan = plans[plan];
  const comparisonData = [{
    situation: 'Ya no saben de qué hablar si no es del bebé',
    without: 'Silencio o tensión',
    with: 'Protocolo de 15 min diarios para volver a conectar'
  }, {
    situation: 'Uno siente que hace más que el otro',
    without: 'Resentimiento sin nombre',
    with: 'Tabla de redistribución de tareas sin drama'
  }, {
    situation: 'El contacto físico desapareció',
    without: 'Distancia que crece sola',
    with: 'Plan de acercamiento gradual, sin presión'
  }, {
    situation: 'Cada uno procesa el agotamiento por su lado',
    without: 'Dos personas en paralelo',
    with: 'Herramientas de comunicación para la crianza real'
  }, {
    situation: 'La familia opina y genera conflicto',
    without: 'Peleas que no cierran',
    with: 'Scripts de frente unido para decisiones en pareja'
  }];
  return <section id="pricing" className="py-6 md:py-10 px-4 bg-navy-950 relative overflow-hidden" data-id="element-192">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-193">
        <FadeIn data-id="element-194">
          <div className="text-center mb-10" data-id="element-195">
            <h2 className="text-sm font-bold tracking-widest text-red-500 uppercase mb-6 drop-shadow-[0_0_8px_rgba(239,68,68,0.2)]" data-id="element-196">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-197" />

            <div className="max-w-sm mx-auto mt-8 bg-navy-800/40 border border-navy-700/50 rounded-xl p-4 backdrop-blur-sm" data-id="element-198">
              <div className="flex justify-between items-center text-xs font-bold mb-2 uppercase tracking-wider" data-id="element-199">
                <span className="text-gray-200 flex items-center gap-1.5" data-id="element-200">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" data-id="element-201"></span>
                  Alta demanda
                </span>
                <span className="text-red-500 font-black" data-id="element-202">89% Reclamado</span>
              </div>
              <div className="h-1.5 bg-navy-900 rounded-full overflow-hidden border border-navy-800" data-id="element-203">
                <div className="h-full bg-gradient-to-r from-yellow-500 via-amber-500 to-red-500 w-[89%] rounded-full relative" data-id="element-204">
                  <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-205"></div>
                </div>
              </div>
              <p className="text-[11px] text-gray-300 mt-2.5 font-medium" data-id="element-206">
                Últimos accesos disponibles a precio de lanzamiento
              </p>
            </div>

            <p className="text-gray-100 mt-6 font-medium" data-id="element-207">
              ⚠️ Después sube $5.000 ARS. No vuelve.
            </p>
          </div>

          <div className="text-center mb-8" data-id="element-208">
            <h3 className="text-3xl md:text-5xl font-serif font-black text-white uppercase tracking-tight" data-id="element-209">
              ELEGÍ TU{' '}
              <span className="text-green-400 drop-shadow-[0_0_15px_rgba(74,222,128,0.3)]" data-id="element-210">
                MEGAPACK
              </span>
            </h3>
          </div>

          <div id="planes-container" className="space-y-4 mb-8 scroll-mt-24 max-w-3xl mx-auto" data-id="element-211">
            {(Object.values(plans) as any[]).map(p => {
            const isSelected = plan === p.id;
            return <button key={p.id} id={`plan-${p.id}`} onClick={() => setPlan(p.id)} className={`w-full text-left transition-all duration-300 rounded-2xl p-6 md:p-8 border-2 flex items-center gap-4 md:gap-6 relative overflow-hidden scroll-mt-28 md:scroll-mt-32 ${isSelected ? 'bg-gradient-to-br from-navy-800 to-navy-900 border-yellow-400 shadow-[0_0_30px_rgba(250,204,21,0.15)] transform scale-[1.02] z-10' : 'bg-navy-800/60 border-navy-700 hover:border-navy-600 hover:bg-navy-800'}`} data-id="element-212">
                  {isSelected && <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-yellow-400 to-amber-500" data-id="element-213" />}

                  {/* Radio Indicator */}
                  <div className={`w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${isSelected ? 'border-yellow-400 bg-yellow-400/10' : 'border-gray-500 bg-navy-900/50'}`} data-id="element-214">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-yellow-400 shadow-[0_0_10px_rgba(250,204,21,0.8)]" data-id="element-215" />}
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0" data-id="element-216">
                    <div className="flex items-center flex-wrap gap-2 mb-1" data-id="element-217">
                      <span className="text-xl shrink-0" data-id="element-218">{p.icon}</span>
                      <h4 className={`text-base md:text-xl font-bold uppercase tracking-tight break-words ${isSelected ? 'text-yellow-400' : 'text-white'}`} data-id="element-219">
                        {p.title}
                      </h4>
                      {p.isPopular && <span className="text-[10px] md:text-xs bg-gradient-to-r from-yellow-400 to-amber-500 text-navy-950 font-black px-3 py-0.5 rounded-full shadow-[0_0_15px_rgba(250,204,21,0.4)] uppercase tracking-wider ml-1" data-id="element-220">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className={`text-xs md:text-base mb-1 break-words ${isSelected ? 'text-gray-100' : 'text-gray-200'}`} data-id="element-221">
                      {p.subtitle}
                    </p>
                    <p className={`text-[10px] md:text-sm font-medium break-words ${isSelected ? 'text-yellow-200/90' : 'text-gray-300'}`} data-id="element-222">
                      {p.ideal}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right shrink-0 ml-auto" data-id="element-223">
                    <p className={`line-through text-[10px] md:text-sm mb-1 ${isSelected ? 'text-gray-200' : 'text-gray-300'}`} data-id="element-224">
                      {p.oldPrice}
                    </p>
                    <p className={`text-xl md:text-4xl font-black transition-colors ${isSelected ? 'text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.4)]' : 'text-white'}`} data-id="element-225">
                      {p.price}{' '}
                      <span className={`text-[10px] md:text-sm font-bold block md:inline ${isSelected ? 'text-yellow-400/70' : 'text-gray-400'}`} data-id="element-226">
                        ARS
                      </span>
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <div className="mb-12 max-w-3xl mx-auto" data-id="element-227">
            {plan === 'premium' && <div className="text-center mb-4" data-id="element-228">
                <p className="text-green-400 font-bold text-sm md:text-base uppercase tracking-wider drop-shadow-[0_0_10px_rgba(74,222,128,0.2)]" data-id="element-229">
                  El combo más elegido por parejas que quieren recuperar el
                  sueño y el vínculo.
                </p>
              </div>}
            <a href={currentPlan.url} className="w-full bg-gradient-to-r from-yellow-400 via-yellow-500 to-amber-500 hover:from-yellow-300 hover:via-yellow-400 hover:to-amber-400 text-navy-950 font-black text-lg md:text-2xl py-5 md:py-6 px-4 rounded-2xl flex items-center justify-center transition-all transform hover:scale-[1.03] active:scale-[0.98] shadow-[0_0_40px_rgba(250,204,21,0.4)] border border-yellow-300/50 text-center break-words leading-tight relative overflow-hidden group" data-id="element-230">
              <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-shine" data-id="element-231" />
              <span className="relative z-10" data-id="element-232">
                {plan === 'premium' ? '→ QUIERO EL MEGAPACK + RECONEXIÓN' : '→ QUIERO MI MEGAPACK'}
              </span>
            </a>
            <div className="flex flex-col items-center mt-6 text-gray-100 text-sm gap-2" data-id="element-233">
              <p className="flex items-center gap-2" data-id="element-234">
                <span className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse" data-id="element-235" />
                Acceso inmediato por email • Pago seguro
              </p>
            </div>
          </div>

          {/* Upsell / Reconexión Section */}
          <div className="bg-navy-900 border border-navy-700 rounded-3xl overflow-hidden shadow-2xl" data-id="element-236">
            <div className="p-6 md:p-10 text-center border-b border-navy-800" data-id="element-237">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-238">
                💑 ¿Qué cambia cuando sumás la Guía Reconexión?
              </h3>
              <p className="text-gray-200 text-base md:text-lg" data-id="element-239">
                Porque el agotamiento nocturno no solo afecta el sueño. Afecta
                la pareja.
              </p>
            </div>

            <div className="p-4 md:p-8 space-y-6" data-id="element-240">
              {/* Desktop Header (Hidden on Mobile) */}
              <div className="hidden md:grid grid-cols-12 gap-4 pb-4 border-b border-navy-800 text-sm font-bold uppercase tracking-wider" data-id="element-241">
                <div className="col-span-5 text-white" data-id="element-242">Situación</div>
                <div className="col-span-3 text-gray-300 text-center" data-id="element-243">
                  ❌ Sin Reconexión
                </div>
                <div className="col-span-4 text-green-400" data-id="element-244">
                  ✅ Con Reconexión
                </div>
              </div>

              {/* Rows */}
              {comparisonData.map((row, idx) => <div key={idx} className="flex flex-col md:grid md:grid-cols-12 gap-2 md:gap-4 pb-6 md:pb-4 border-b border-navy-800/50 last:border-0 last:pb-0" data-id="element-245">
                  <div className="md:col-span-5 text-gray-100 font-medium text-base mb-2 md:mb-0" data-id="element-246">
                    {row.situation}
                  </div>
                  <div className="md:col-span-3 text-gray-300 italic text-sm md:text-base flex items-start md:justify-center" data-id="element-247">
                    <span className="md:hidden mr-2" data-id="element-248">❌</span>
                    {row.without}
                  </div>
                  <div className="md:col-span-4 text-white font-medium text-sm md:text-base bg-green-400/5 p-3 md:p-2 rounded-lg md:rounded-none md:bg-transparent flex items-start mt-2 md:mt-0 border border-green-400/10 md:border-0" data-id="element-249">
                    <span className="md:hidden mr-2" data-id="element-250">✅</span>
                    {row.with}
                  </div>
                </div>)}
            </div>

            <div className="p-6 md:p-8 bg-navy-800/30 border-t border-navy-700" data-id="element-251">
              <div className="flex flex-col items-center text-center" data-id="element-252">
                <div className="text-yellow-400 text-sm mb-3 drop-shadow-[0_0_8px_rgba(250,204,21,0.4)]" data-id="element-253">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-gray-100 italic text-sm md:text-base max-w-2xl" data-id="element-254">
                  "Después de meses sin dormir ya casi no nos hablábamos. La
                  Guía Reconexión nos dio un lenguaje común para atravesar esto
                  juntos. No es terapia, es muy práctico."
                </p>
                <p className="text-gray-300 text-xs mt-3 font-bold" data-id="element-255">
                  — Carolina R. · Mendoza
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};